module.exports = "/wp-content/plugins/farmacy/assets/js/images/menu-edibles-icon-2-f6c7ab83136759aa8e671918e80886af.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/elo-app/img/category_icons/menu-edibles-icon-2.svg
 ** module id = 1005
 ** module chunks = 1 75
 **/